/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_Not_ConfiguredInputs */

const cs_auth_meta_not_configured = /** @type {(inputs: Auth_Meta_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Meta není na tomto serveru nastavené. Požádejte správce.`)
};

const en_auth_meta_not_configured = /** @type {(inputs: Auth_Meta_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta sign-in is not configured on this server. Ask an administrator.`)
};

/**
* | output |
* | --- |
* | "Meta sign-in is not configured on this server. Ask an administrator." |
*
* @param {Auth_Meta_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_not_configured = /** @type {((inputs?: Auth_Meta_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_not_configured(inputs)
	return cs_auth_meta_not_configured(inputs)
});